import React, { useEffect, useState, useContext } from 'react'
import UserTableView from './TableView'
import { Button } from '@mui/material'
import Layout from '@/product/components/templates/Layout'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ReportContext from '@/product/context/report/reportContext'
import OrgManage from './OrgManage'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import { NoStroller } from '@mui/icons-material'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const history = useHistory()
    const { user_tablefields } = dynamicContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        handleRedirectInternal(history, `seller/edit/${id}`)
    }
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `seller/edit/${id}`)
        }
    }

    const [tableValue, setTableValue] = useState([])
    const [searchInfo, setSearchInfo] = useState({})
    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null

    const custom = {
        action: {
            value: action,
            type: 'in',
            field: 'u.status',
        },
        admin: {
            value: '1',
            type: 'in',
            field: 'u.admin',
        },
    }

    useEffect(() => {
        if (user_tablefields && user_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = [...user_tablefields]
            let tableFields = [
                ...user_tablefields,
                {
                    view_page: '3',
                    filter_type: 'in',
                    field: 'created_at',
                    is_default: 1,
                    type: 'datetime',

                    label: 'Created At',
                    name: 'created_at',
                },
            ]

            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            tableFields.map((data) => {
                if (data.field === 'email') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })

            dynamicValueAssign.data.push({
                view_page: '3',
                filter_type: 'in',
                field: 'is_requested',
                is_default: 1,
                type: 'switch',
                // type: 'text',
                label: 'Requested user',
                name: 'is_requested',
                filter: true,
            })
            setTableValue(tableFields)
            setSearchInfo(dynamicValueAssign)
        }
    }, [user_tablefields, action])

    const exportFields = [
        {
            name: 'Id',
            field: 'id',
            type: '',
        },
        {
            name: 'User Id',
            field: 'username',
            type: '',
        },
        { name: 'First Name', field: 'first_name', type: '' },
        { name: 'Last Name', field: 'last_name', type: '' },
        {
            name: 'Email',
            field: 'email',
            type: '',
        },
        {
            name: 'Company Name',
            field: 'companyname',
            type: '',
        },

        {
            name: 'Job Title',
            field: 'job_title',
            type: '',
        },

        {
            name: ' Created Date',
            field: 'created_at',
            type: 'datetime',
        },
        {
            name: 'Last Login',
            field: 'last_login',
            type: 'datetime',
        },
        { name: 'Status', field: 'status', type: 'capitalize' },
    ]

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="org_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                handleRedirectInternal(history, `seller/new/0`)
                            }
                        >
                            <span className="material-icons">
                                person_add_alt_1
                            </span>
                            Add Individual User
                        </Button>
                        <Button
                            id="org_report"
                            onClick={() =>
                                getAllExportDownload({
                                    fields: exportFields,
                                    isDefault: false,
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_seller_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>

                    <UserTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={['active', 'rejected', 'deactivate']}
                        action={action}
                        advFilters={true}
                        requestUserAccess={true}
                        listActionString={['cancelrequest', 'switchuser']}
                        seller={true}
                    />
                </div>
                {/* <OrgManage data={manage} function={toggleFullScreenPopup} /> */}
            </Layout>
        </>
    )
}

export default UserCommon
